const Spinner = () => {
  return (
    <div className="flex justify-center items-center h-full flex-1 min-h-0">
      <div className="relative w-12 h-12">
        {/* Background track */}
        <div className="absolute inset-0 border-[2px] border-[#8b5cf6]/10 rounded-full"></div>
        {/* Spinning part */}
        <div className="absolute inset-0 border-t-[2px] border-[#8b5cf6] rounded-full animate-spin shadow-[0_0_8px_rgba(139,92,246,0.2)]"></div>
      </div>
    </div>
  );
};

export default Spinner;
